// ============================================================
//  MASAMADREAM — Process Data
//  Fuente de verdad: actividades P1 y P2
// ============================================================

// Cada actividad: { id, day, time, action, description, duration }
// time: offset en HORAS desde el inicio del proceso

export const PROCESSES = {

  // ── P1: Fermentación desde Cero (7 días) ─────────────────
  p1: {
    label:    'Fermentación',
    emoji:    '🌱',
    totalDays: 7,
    activities: [
      {
        id: 'p1-d1-a1',
        day: 1,
        timeOffset: 0,
        action: 'Mezcla Inicial',
        description: 'Mezcla 50 g de harina y 50 ml de agua en un frasco.',
        duration: '10 min',
        emoji: '🥣',
        instructions: [
          'Lava bien el frasco de vidrio con agua caliente — sin jabón para no matar las levaduras.',
          'Pesa 50 g de harina de trigo integral o de centeno (preferiblemente orgánica).',
          'Pesa 50 ml de agua sin cloro: usa agua filtrada o deja reposar el agua del grifo 30 min.',
          'Vierte el agua en el frasco primero, luego la harina.',
          'Mezcla vigorosamente con una cuchara limpia hasta que no queden grumos secos.',
          'Marca el nivel de la mezcla con una liga o un marcador en el vidrio.',
          'Cubre con un paño limpio o una tapa suelta — nunca hermético, necesita respirar.',
          'Deja reposar a temperatura ambiente (ideal 21–24 °C). ¡El proceso ha comenzado!',
        ],
      },
      {
        id: 'p1-d2-a1',
        day: 2,
        timeOffset: 24,
        action: 'Alimentar',
        description: 'Añade 50 g de harina y 50 ml de agua. Descarta la mitad.',
        duration: '5 min',
        emoji: '🌾',
        instructions: [
          'Observa la mezcla: puede haber pequeñas burbujas o un ligero olor ácido — ¡es normal!',
          'Con una cuchara, retira y descarta la mitad de la mezcla (aprox. 50 g).',
          'Pesa 50 g de harina fresca (puedes mezclar 50% trigo / 50% centeno para más actividad).',
          'Pesa 50 ml de agua sin cloro a temperatura ambiente.',
          'Añade el agua primero, luego la harina, y mezcla bien.',
          'Actualiza la marca de nivel en el frasco.',
          'Devuelve al mismo lugar a temperatura ambiente.',
          '💡 Tip: el descarte se puede usar para hacer panqueques o crackers.',
        ],
      },
      {
        id: 'p1-d3-a1',
        day: 3,
        timeOffset: 48,
        action: 'Alimentar',
        description: 'Repite el procedimiento (50 g harina, 50 ml agua).',
        duration: '5 min',
        emoji: '🌾',
        instructions: [
          'Para el Día 3 ya deberías ver más burbujas y un olor más pronunciado — ¡va bien!',
          'Descarta la mitad de la mezcla antes de alimentar.',
          'Agrega 50 g de harina y 50 ml de agua sin cloro.',
          'Mezcla bien hasta integrar completamente.',
          'Marca el nuevo nivel.',
          '💡 Si ves que dobló su volumen desde la alimentación anterior, ¡tus levaduras están activas!',
          'Mantén a temperatura constante. Evita cambios bruscos de temperatura.',
        ],
      },
      {
        id: 'p1-d4-a1',
        day: 4,
        timeOffset: 72,
        action: 'Alimentar',
        description: 'Continúa alimentando la mezcla (50 g harina, 50 ml agua).',
        duration: '5 min',
        emoji: '🌾',
        instructions: [
          'El olor debería ser más ácido y agradable, como yogur o vinagre suave.',
          'Descarta la mitad antes de alimentar.',
          'Añade 50 g de harina y 50 ml de agua.',
          'Mezcla bien y marca el nivel.',
          '💡 Si el cultivo parece "lento", prueba a mantenerlo en un lugar más cálido (25–27 °C).',
          'Puedes empezar a ver una capa líquida grisácea arriba — es "hooch", señal de hambre. ¡Normal!',
        ],
      },
      {
        id: 'p1-d5-a1',
        day: 5,
        timeOffset: 96,
        action: 'Alimentar',
        description: 'Repite el procedimiento (50 g harina, 50 ml agua).',
        duration: '5 min',
        emoji: '🌾',
        instructions: [
          'A estas alturas el cultivo debería tener una actividad visible: burbujas, crecimiento, buen olor.',
          'Descarta la mitad antes de alimentar.',
          'Añade 50 g de harina y 50 ml de agua. Mezcla bien.',
          'Marca el nivel y observa cuánto crece en las próximas horas.',
          '💡 Prueba de flotación: coloca una cucharita en agua. Si flota, ¡casi lista!',
          'Si no flota todavía, no te preocupes — sigue el proceso 1–2 días más.',
        ],
      },
      {
        id: 'p1-d6-a1',
        day: 6,
        timeOffset: 120,
        action: 'Alimentar',
        description: 'Realiza la misma alimentación (50 g harina, 50 ml agua).',
        duration: '5 min',
        emoji: '🌾',
        instructions: [
          'El cultivo debería estar muy activo ahora: dobla su volumen, burbujea, huele bien.',
          'Descarta la mitad y alimenta con 50 g harina + 50 ml agua.',
          'Mezcla bien y marca el nivel.',
          '💡 Ideal para usar: 4–8 horas después de alimentar, cuando está en su pico de actividad.',
          'El "pico" es cuando está más alto antes de empezar a bajar — ese es el momento perfecto.',
        ],
      },
      {
        id: 'p1-d7-a1',
        day: 7,
        timeOffset: 144,
        action: 'Alimentar y Verificar',
        description: 'Alimenta y verifica si tu masa madre está lista para usar.',
        duration: '10 min',
        emoji: '🧪',
        instructions: [
          'Realiza la alimentación normal: descarta la mitad, añade 50 g harina + 50 ml agua.',
          'Espera 4–6 horas y realiza la prueba de flotación: ¿flota una cucharita en agua? ✅',
          'Comprueba que haya doblado (o más) su volumen desde la alimentación.',
          'El olor debe ser agradablemente ácido, a levadura o queso joven.',
          'La textura al mezclar debe ser elástica y llena de burbujas.',
          '¡Si pasa todas las pruebas, tu masa madre ESTÁ LISTA para hacer pan! 🍞',
          '💡 Para mantenerla: refrigera y alimenta 1 vez por semana. ¡Puede vivir años!',
        ],
      },
    ],
  },

  // ── P2: Preparación del Pan (5 etapas) ────────────────────
  p2: {
    label:    'Preparación',
    emoji:    '🍞',
    totalDays: 5,
    activities: [
      {
        id: 'p2-d1-a1',
        day: 1,
        timeOffset: 0,
        action: 'Pesar Ingredientes',
        description: 'Pesar todos los ingredientes necesarios para la receta.',
        duration: '10 min',
        emoji: '⚖️',
        instructions: [
          'Receta base para 1 hogaza (850 g aprox):',
          '• 450 g de harina de trigo (preferiblemente de fuerza, W200+)',
          '• 320 ml de agua sin cloro (hidratación ~71%)',
          '• 100 g de masa madre activa (en su pico)',
          '• 9 g de sal marina fina',
          'Usa una balanza de precisión — en panadería los gramos importan.',
          '💡 Asegúrate de que tu masa madre esté activa: alimentala 4–8 horas antes.',
        ],
      },
      {
        id: 'p2-d1-a2',
        day: 1,
        timeOffset: 0.17,
        action: 'Mezcla Inicial',
        description: 'Mezclar agua con la masa madre en un tazón grande.',
        duration: '5 min',
        emoji: '🫙',
        instructions: [
          'En un tazón grande, vierte el agua a temperatura ambiente (24–26 °C).',
          'Añade la masa madre activa al agua.',
          'Mezcla con los dedos o una espátula hasta disolver la masa madre.',
          '💡 El agua tibia activa la fermentación más rápido. Evita agua caliente.',
          'La mezcla debe quedar lechosa y uniforme antes de añadir la harina.',
        ],
      },
      {
        id: 'p2-d1-a3',
        day: 1,
        timeOffset: 0.25,
        action: 'Agregar Harina y Sal',
        description: 'Integrar la harina y la sal hasta obtener una pasta pegajosa.',
        duration: '5 min',
        emoji: '🧂',
        instructions: [
          'Añade toda la harina a la mezcla de agua y masa madre.',
          'Mezcla con las manos o una espátula hasta que no queden partes secas.',
          'La masa quedará pegajosa y rugosa — es completamente normal.',
          'Agrega la sal encima de la masa y pellizca con los dedos para integrarla.',
          '💡 No amasas todavía — solo integrar. El gluten se desarrolla en el reposo.',
          'Cubre el tazón con film plástico o un gorro de ducha reutilizable.',
        ],
      },
      {
        id: 'p2-d1-a4',
        day: 1,
        timeOffset: 0.5,
        action: 'Reposo Inicial',
        description: 'Cubrir y dejar reposar 1 hora (autólisis).',
        duration: '1 hora',
        emoji: '💤',
        instructions: [
          'Este proceso se llama "autólisis" — la harina absorbe el agua y el gluten comienza a formarse solo.',
          'Cubre el tazón y déjalo reposar 1 hora a temperatura ambiente.',
          'NO manipules la masa durante este tiempo.',
          '💡 Después de la autólisis verás que la masa cambió: más suave, más extensible y menos pegajosa.',
          'Este paso hace que el amasado posterior sea mucho más fácil.',
        ],
      },
      {
        id: 'p2-d2-a1',
        day: 2,
        timeOffset: 24,
        action: 'Pliegues',
        description: '4 series de pliegues con las manos mojadas, cada hora por 4 horas.',
        duration: '5 min c/hora × 4',
        emoji: '🤲',
        instructions: [
          'Mójate las manos para evitar que la masa se pegue.',
          'Toma un extremo de la masa, estíralo hacia arriba y dóblalo al centro.',
          'Gira el tazón 90° y repite. Haz esto 4 veces por cada serie (Norte-Sur-Este-Oeste).',
          'Notarás que la masa se vuelve más tensa y elástica con cada serie.',
          '⏱️ Repite este proceso 4 veces, dejando 1 hora de reposo entre cada serie.',
          '💡 El objetivo es desarrollar fuerza y estructura en la masa sin calentarla.',
          'Después de la última serie, deja reposar sin tocar hasta la formación (Día 3).',
        ],
      },
      {
        id: 'p2-d3-a1',
        day: 3,
        timeOffset: 28,
        action: 'Formación de Hogazas',
        description: 'Preformar, reposar 20 min, formar y refrigerar en banetton.',
        duration: '15 min + refrigeración',
        emoji: '🫓',
        instructions: [
          'Enharina ligeramente la superficie de trabajo.',
          'Vuelca la masa con cuidado y deja reposar 15–20 min destapada (bench rest).',
          'Preforma: dóblala sobre sí misma suavemente para crear tensión superficial.',
          'Después de 20 min, forma la hogaza final: dobla los lados hacia el centro, enrolla y sella.',
          'Enharina bien el banetton (o un bol forrado con paño enharinado).',
          'Coloca la hogaza con la costura hacia arriba en el banetton.',
          'Cubre con film plástico y lleva al refrigerador (4–6 °C).',
          '💡 La fermentación fría desarrolla más sabor. Puede estar 24–48 horas en la nevera.',
        ],
      },
      {
        id: 'p2-d4-a1',
        day: 4,
        timeOffset: 72,
        action: 'Sacar y Reposar',
        description: 'Sacar del refrigerador y dejar reposar 1–2 horas.',
        duration: '1–2 horas',
        emoji: '⏱️',
        instructions: [
          'Saca el banetton del refrigerador con cuidado — no golpees la hogaza.',
          'Déjala reposar a temperatura ambiente 1–2 horas sin destapar.',
          'Mientras, enciende el horno (siguiente actividad).',
          '💡 El reposo permite que la masa se atempere y esté lista para el horno.',
          'Sabrás que está lista cuando al presionar suavemente con el dedo, regresa lentamente.',
        ],
      },
      {
        id: 'p2-d4-a2',
        day: 4,
        timeOffset: 74,
        action: 'Precalentar Horno',
        description: 'Precalentar el horno y la olla de hierro a 500°F / 260°C por 20 min.',
        duration: '20 min',
        emoji: '🔥',
        instructions: [
          'Coloca la olla de hierro fundido (Dutch oven) dentro del horno con la tapa.',
          'Enciende el horno a máxima temperatura: 500°F (260°C) o lo más alto posible.',
          'Precalienta por al menos 20 minutos — la olla debe estar MUY caliente.',
          '💡 La olla caliente crea vapor al sellarla, lo que produce una corteza crujiente.',
          'Si no tienes olla de hierro, usa una bandeja profunda con tapa o papel aluminio.',
          'Ten a mano: papel pergamino, una navaja o cuchillo muy afilado para greñar.',
        ],
      },
      {
        id: 'p2-d5-a1',
        day: 5,
        timeOffset: 96,
        action: 'Hornear Tapado',
        description: 'Hornear 25 min a 500°F tapado con vapor.',
        duration: '25 min',
        emoji: '🍳',
        instructions: [
          'Corta un trozo de papel pergamino del tamaño del fondo de la olla.',
          'Vuelca la hogaza sobre el papel pergamino (costura abajo, parte lisa arriba).',
          'Con una navaja o cuchillo muy afilado, haz un corte diagonal de 1–2 cm de profundidad.',
          'Con mucho cuidado saca la olla del horno (¡usa guantes gruesos!).',
          'Levanta la hogaza con el papel y colócala dentro de la olla.',
          'Tapa la olla y hornea por 25 minutos a 500°F.',
          '💡 El vapor atrapado dentro es lo que permite que el pan se expanda correctamente.',
          'No abras la tapa durante estos 25 minutos.',
        ],
      },
      {
        id: 'p2-d5-a2',
        day: 5,
        timeOffset: 96.42,
        action: 'Hornear Destapado',
        description: 'Quitar la tapa y hornear a 450°F por 20 min para la corteza.',
        duration: '20 min',
        emoji: '🥐',
        instructions: [
          'Con cuidado, retira la tapa de la olla (¡guantes!).',
          'Baja la temperatura a 450°F (230°C).',
          'Hornea sin tapa por 20 minutos más.',
          'Observa el color: debe quedar marrón oscuro — no tengas miedo del color.',
          '💡 Una corteza más oscura = más sabor y mejor textura. El pan "crudo" es color caramelo oscuro.',
          'El pan está listo cuando suena hueco al golpear el fondo.',
        ],
      },
      {
        id: 'p2-d5-a3',
        day: 5,
        timeOffset: 96.75,
        action: 'Reposo Final',
        description: 'Sacar del horno y reposar al menos 30 min antes de cortar.',
        duration: '30+ min',
        emoji: '🎉',
        instructions: [
          'Saca el pan de la olla y colócalo sobre una rejilla.',
          'Escucharás crepitar la corteza — ¡eso es la magia del pan de masa madre!',
          'Espera MÍNIMO 30 minutos antes de cortar. 1 hora es lo ideal.',
          '💡 El pan sigue cocinándose internamente con el calor residual después de salir del horno.',
          'Si cortas demasiado pronto, el interior quedará gomoso.',
          '¡Disfruta tu pan artesanal de masa madre! 🍞✨',
        ],
      },
    ],
  },
  // ── P3: Pan de Pizza con Masa Madre ──────────────────────
  p3: {
    label:    'Pizza',
    emoji:    '🍕',
    totalDays: 2,
    activities: [
      {
        id: 'p3-d1-a1',
        day: 1,
        timeOffset: 0,
        action: 'Autólisis',
        description: 'Mezcla harina y agua hasta integrar, tapa 20 min.',
        duration: '20 min',
        emoji: '🥣',
        instructions: [
          'Ingredientes para 2 pizzas (28–30 cm):',
          '• 400 g de harina de fuerza (panadera, W260+)',
          '• 250 ml de agua tibia',
          '• 150 g de masa madre activa (100% hidratación)',
          '• 8 g de sal',
          '• 15 ml de aceite de oliva (opcional — da suavidad)',
          'En un bol grande, vierte el agua tibia primero.',
          'Añade la harina y mezcla con las manos o espátula hasta que no queden restos secos.',
          'Tapa el bol con film o un paño húmedo y deja reposar 20 minutos.',
          '💡 Este reposo (autólisis) permite que el gluten se forme solo — la masa será más extensible.',
        ],
      },
      {
        id: 'p3-d1-a2',
        day: 1,
        timeOffset: 0.33,
        action: 'Añadir Masa Madre y Amasar',
        description: 'Incorpora masa madre, sal y aceite. Amasa 5–7 min.',
        duration: '10 min',
        emoji: '🤲',
        instructions: [
          'Agrega los 150 g de masa madre activa sobre la mezcla reposada.',
          'Añade los 8 g de sal (y el aceite de oliva si lo usas).',
          'Amasa durante 5–7 minutos hasta obtener una masa lisa y elástica.',
          'La masa puede estar ligeramente pegajosa — es normal a esta hidratación.',
          'Prueba de ventana: estira un trozo fino entre los dedos. Si se transparenta sin romperse, está lista.',
          '💡 Si se rompe enseguida, amasa 2 minutos más y vuelve a probar.',
          'Forma una bola y coloca en un bol ligeramente aceitado.',
        ],
      },
      {
        id: 'p3-d1-a3',
        day: 1,
        timeOffset: 0.5,
        action: 'Fermentación en Frío',
        description: 'Tapa y lleva a la nevera 12–16 h para más sabor.',
        duration: '12–16 horas',
        emoji: '🧊',
        instructions: [
          'Cubre el bol herméticamente con film plástico.',
          'Introduce en la nevera (4–6 °C).',
          'La fermentación lenta en frío desarrolla más sabor y hace la masa más digestible.',
          '💡 Alternativa rápida: si tienes prisa, deja a temperatura ambiente (22–24 °C) 3–4 horas haciendo pliegues cada 45 min.',
          'Para la opción en frío, la masa puede estar entre 12 y 16 horas — ¡no pasa nada si son 18!',
          'Mañana retomas desde aquí. ¡Buenas noches, panadero! 🌙',
        ],
      },
      {
        id: 'p3-d2-a1',
        day: 2,
        timeOffset: 13,
        action: 'Dividir y Formar Bolas',
        description: 'Saca de nevera, divide en 2 y deja reposar 20–30 min.',
        duration: '30 min',
        emoji: '⚖️',
        instructions: [
          'Saca el bol de la nevera y deja atemperar 15 minutos.',
          'Vuelca la masa sobre una superficie ligeramente enharinada.',
          'Con un cuchillo o rasqueta, divide en 2 porciones iguales (≈ 400 g cada una).',
          'Forma una bola tensa con cada porción: dobla los bordes hacia el centro y séllala.',
          'Coloca las bolas con la costura hacia abajo, separadas, tapadas con un paño.',
          'Deja reposar 20–30 minutos a temperatura ambiente.',
          '💡 Este reposo relaja el gluten — si estiras sin reposar, la masa se encoge como un elástico.',
          'No uses demasiada harina o perderás las burbujas de CO₂ que dan textura al borde.',
        ],
      },
      {
        id: 'p3-d2-a2',
        day: 2,
        timeOffset: 13.5,
        action: 'Precalentar Horno',
        description: 'Precalienta horno al máximo con piedra o bandeja adentro, 45 min.',
        duration: '45 min',
        emoji: '🔥',
        instructions: [
          'Coloca la piedra para pizza o una bandeja pesada boca abajo en la rejilla más alta.',
          'Enciende el horno a la temperatura máxima: 250–280 °C (480–540 °F).',
          'Precalienta al menos 45 minutos — la piedra o bandeja debe estar muy caliente.',
          '💡 El calor acumulado en la piedra es lo que da la base crujiente y el borde aireado.',
          'Mientras precalienta, prepara los toppings (salsa, queso, ingredientes).',
          'Mantén los toppings ligeros — demasiado peso aplana las burbujas del borde.',
        ],
      },
      {
        id: 'p3-d2-a3',
        day: 2,
        timeOffset: 14.25,
        action: 'Estirar la Masa',
        description: 'Aplana con las manos desde el centro dejando el borde grueso.',
        duration: '10 min',
        emoji: '👐',
        instructions: [
          'Enharina muy ligeramente la superficie y toma una bola de masa.',
          'Con los dedos, presiona desde el centro hacia afuera formando un círculo.',
          'Levanta la masa y estírala con los nudillos, girando mientras la dejas caer.',
          'Deja el borde exterior más grueso (1–2 cm) — ahí estarán las burbujas.',
          '⚠️ No uses rodillo en el borde: lo aplana y pierde el aire.',
          '💡 Si la masa se retrae, déjala reposar 5 min y vuelve a intentarlo.',
          'Objetivo: disco de 28–30 cm, más fino en el centro y más grueso en el borde.',
          'Transfiere a papel pergamino o pala enharinada con semolina para el horneado.',
        ],
      },
      {
        id: 'p3-d2-a4',
        day: 2,
        timeOffset: 14.5,
        action: 'Montar y Hornear',
        description: 'Añade toppings y hornea 7–10 min hasta borde dorado.',
        duration: '10 min',
        emoji: '🍕',
        instructions: [
          'Con la masa estirada sobre el papel pergamino, añade una capa fina de salsa (no excedas los bordes).',
          'Agrega queso y toppings — ligeros y en capas finas para un horneado parejo.',
          'Desliza la pizza (con el papel) sobre la piedra o bandeja caliente.',
          'Hornea 7–10 minutos: el borde debe estar dorado y con manchas oscuras, la base tostada.',
          '💡 En hornos caseros a 250 °C, 8–9 min suele ser perfecto.',
          'Retira con la pala o con pinzas y el papel.',
          'Deja reposar 1–2 min antes de cortar para que el queso se asiente.',
          '¡Disfruta tu pizza de masa madre! 🍕✨',
        ],
      },
    ],
  },

};

// Frases motivacionales para el centro del reloj
export const PHRASES = [
  '¡Tu masa está creciendo! 🌱',
  '¡Paciencia, panadero! 🕐',
  '¡Las bacterias trabajan duro! 🦠',
  '¡Pronto tendrás un pan increíble! 🍞',
  '¡La fermentación es magia lenta! ✨',
  '¡Tu cultivo está vivo! ❤️',
  '¡Cada alimentación cuenta! 💪',
  'La naturaleza sigue su ritmo 🌿',
  '¡Eres un maestro panadero! 👨‍🍳',
  '¡El aroma será increíble! 👃',
];
